export default "__VITE_PUBLIC_ASSET__adb7a472__"